import { Navbar } from "@/components/layout/Navbar"
import { Footer } from "@/components/layout/Footer"
import { Hero } from "@/components/sections/Hero"
import { TrustBar } from "@/components/sections/TrustBar"
import { HowItWorks } from "@/components/sections/HowItWorks"
import { LiveTradeCommandCenter } from "@/components/sections/LiveTradeCommandCenter"
import { PanIndiaNetwork } from "@/components/sections/PanIndiaNetwork"
import { RoleCards } from "@/components/sections/RoleCards"
import { FinalCTA } from "@/components/sections/FinalCTA"

export function HomePage() {
  return (
    <div className="min-h-screen bg-surface flex flex-col text-on-surface">
      <Navbar />

      <main className="flex-grow">
        <Hero />
        <TrustBar />
        <HowItWorks />
        <LiveTradeCommandCenter />
        <PanIndiaNetwork />
        <RoleCards />
        <FinalCTA />
      </main>

      <Footer />
    </div>
  )
}
